<mat-card
    class="riege-card"
    [ngClass]="classes()"
    [attr.data-testid]="data().id ? 'riege-card-' + data().id : 'default'">
    <ng-container *ngTemplateOutlet="data().href ? linkedCard : basicCard"></ng-container>

    <ng-template #linkedCard>
        <ng-container *ngTemplateOutlet="data().href?.startsWith('http') ? externalLink : internalLink"></ng-container>

        <ng-template #externalLink>
            <a class="link--box-shadow link--flex-streched" [href]="[data().href]" target="_blank">
                <ng-template *ngTemplateOutlet="cardContent"></ng-template>
            </a>
        </ng-template>

        <ng-template #internalLink>
            <a class="link--box-shadow link--flex-streched" [routerLink]="[data().href]">
                <ng-template *ngTemplateOutlet="cardContent"></ng-template>
            </a>
        </ng-template>
    </ng-template>

    <ng-template #basicCard>
        <ng-template *ngTemplateOutlet="cardContent"></ng-template>
    </ng-template>
</mat-card>

<ng-template #cardContent>
    @if (data().image) {
        <img mat-card-image src="{{ data().image }}" alt="" />
    }
    @if (data().date || data().icon || data().title || data().text) {
        <mat-card-content>
            @if (data().date) {
                <p class="mat-card__overline">{{ data().date | date: 'mediumDate' }}</p>
            }
            @if (data().categories?.length) {
                <mat-chip-set class="riege-chips" aria-label="Services selection">
                    @for (category of data().categories; track data().id) {
                        <mat-chip disabled>
                            <span>{{ category }}</span>
                        </mat-chip>
                    }
                </mat-chip-set>
            }

            @if (data().icon && data().title) {
                <div class="content-header">
                    <div class="mat-card-content__icon">
                        <mat-icon class="riege-icon" alt="" aria-hidden="true" fontIcon="{{ data().icon }}"></mat-icon>
                    </div>

                    <mat-card-title [ngClass]="{ 'reset-margin--bottom': !data().text }">{{
                        data().title
                    }}</mat-card-title>
                </div>
            }
            @if (data().icon && !data().title) {
                <div class="mat-card-content__icon">
                    <mat-icon class="riege-icon" alt="" aria-hidden="true" fontIcon="{{ data().icon }}"></mat-icon>
                </div>
            }
            @if (data().title && !data().icon) {
                <mat-card-title [ngClass]="{ 'reset-margin--bottom': !data().text }">{{ data().title }}</mat-card-title>
            }
            @if (data().text) {
                <p [ngClass]="{ 'reset-margin--bottom': !data().action }">{{ data().text ?? '' | ellipsis: 120 }}</p>
            }
        </mat-card-content>
    }

    @if (data().action) {
        <mat-card-actions> <ng-content select="[action-slot]"></ng-content> </mat-card-actions>
    }
</ng-template>
